import { Component, OnInit, Input, OnChanges } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";

import { UserService } from "../../_services/user.service";
import { CommonService } from "../../_services/common.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { FlashMessagesService } from "angular2-flash-messages";
import * as Materialize from 'materialize-css';

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"]
})
export class ProfileComponent implements OnInit {
  public loading=false;
  profileForm: FormGroup;
  post: any; // A property for our submitted form
  company_name: string = "";
  first_name: string = "";
  middle_name: string = "";
  last_name: string = "";
  email: string = "";
  phone: string = "";
  username: string = "";
  site_url: string = "";
  type: string = "";
  public address1: string = "";
  public address2: string = "";
  public city: string = "";
  public state: string = "";
  public zip: string = "";
  public selectedFile = null;
  public image_path=null;
  public subscriptionExist = 'Yes';
  public userDetails:any = {};
  constructor(
    private userService: UserService,
    private commonService: CommonService,
    private router: Router,
    private fb: FormBuilder,   
    private _flashMessagesService: FlashMessagesService
  ) {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.userDetails = userDetails;    
    this.profileForm = fb.group({
      company_name: [null],
      first_name: [null, Validators.required],
     // middle_name: [null],
      last_name: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, Validators.required],
      username: [null, Validators.required],
      site_url: [null, [Validators.pattern('^(http[s]?:\\/\\/){0,1}(www\\.){0,1}[a-zA-Z0-9\\.\\-]+\\.[a-zA-Z]{2,5}[\\.]{0,1}$')]],
      type: [null, Validators.required],
      image:[null],
      validate: ""
    });
    this.profileForm.setValue({
      company_name: userDetails.company_name,
      first_name: userDetails.first_name,
      //middle_name: userDetails.middle_name,
      last_name: userDetails.last_name,
      email: userDetails.email,
      phone: userDetails.phone,
      username: userDetails.username,
      site_url: userDetails.site_url,
      type: userDetails.type,
      image:'',
      validate: ""
    });
    this.image_path=userDetails.profile_img?userDetails.profile_img:'';
  }

  ngOnInit() {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if(userDetails.type == 'Printer')
    {
      this.profileForm = this.fb.group({
        company_name: [null],
        first_name: [null, Validators.required],
       // middle_name: [null],
        last_name: [null, Validators.required],
        email: [null, [Validators.required, Validators.email]],
        phone: [null, Validators.required],
        username: [null, Validators.required],
        site_url: [null, [Validators.pattern('^(http[s]?:\\/\\/){0,1}(www\\.){0,1}[a-zA-Z0-9\\.\\-]+\\.[a-zA-Z]{2,5}[\\.]{0,1}$')]],
        type: [null, Validators.required],
        address1: [null, Validators.required],
        address2: [null],
        city: [null, Validators.required],
        state: [null, Validators.required],
        zip: [null, Validators.required],        
        image:[null],
        validate: ""
      });    
      this.getProfileOtherDetail(userDetails);
    }
  }

  ngAfterViewInit() {
    Materialize.updateTextFields();
  }

  getProfileOtherDetail = function (udata:any){
    let staffOptions = {}
    this.commonService.apiService(
      "GET",
      'printer/'+udata.id,
      staffOptions
    ).subscribe(
      (response: any) => {       
        if (response.status === true) {
          if (response.data) {
            this.profileForm.setValue({
            'company_name': response.data.company_name,
            'first_name': response.data.first_name,
            //'middle_name': response.data.middle_name,
            'last_name': response.data.last_name,
            'email': response.data.email,
            'phone': response.data.phone,
            'username': response.data.username,
            'site_url': response.data.site_url,
            'type': udata.type,
            'address1' : response.data.address1 ,
            'address2' : response.data.address2,
            'city' : response.data.city,
            'state' : response.data.state,
            'zip' : response.data.zip,            
            'image':'',          
            validate: ""
          });
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  isFieldValid(field: string) {
    return (
      !this.profileForm.get(field).valid && this.profileForm.get(field).touched
    );
  }

  displayFieldCss(field: string) {
    return {
      "has-error": this.isFieldValid(field),
      "has-feedback": this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {     
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  OnSubmit(post) {    
    if (this.profileForm.valid) {      
      post.site_url = post.site_url == null ? '' : post.site_url;
      this.userService.userUpdateProfile(post,this.selectedFile).subscribe(
        (response: any) => {
          if (response.status === true) {
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 5000
            });
            window.scrollTo(0, 0);
            let userDetails = JSON.parse(localStorage.getItem('userDetails'));            
            let allData=Object.assign(response.data,{site_data:userDetails.site_data});            
            localStorage.setItem("userDetails",JSON.stringify(allData));
          }
        },
        err => {}
      );
    } else {
      this.validateAllFormFields(this.profileForm);
    }
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];   
    var render=new FileReader();
    render.onload=(event:any)=>
    {
      this.image_path=event.target.result;    
     
    }
    render.readAsDataURL(this.selectedFile); 
    
  }

 
  
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/profile/profile.component.ts